export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/icon-splash-top-text-light-8446637ed80f08538575d4029312ef74.svg";